module.exports = __webpack_public_path__ + "img/txt.db28fa96.webp";